module.exports = function () { /* empty */ };



//////////////////
// WEBPACK FOOTER
// ../js/~/core-js/library/modules/_add-to-unscopables.js
// module id = 641
// module chunks = 0